class Header {
    constructor() {
        // Select dom items
        const menuBtn = document.querySelector(".menu-btn");
        const menu = document.querySelector(".menu");
        const menuNav = document.querySelector(".menu-nav");
        const menuBranding = document.querySelector(".menu-branding");
        const navItems = document.querySelectorAll(".nav-item");
        var fruin_hamburger_menu = document.getElementById('fruin_hamburger_menu');
        var fruin_hidden_nav = document.getElementById('fruin_hidden_nav');

        // Set the initial state of the menu
        let showMenu = false;

        menuBtn.addEventListener("click", toggleMenu);

        function toggleMenu() {
            if (!showMenu) {
                menuBtn.classList.add("close");
                menu.classList.add("show");
                menuNav.classList.add("show");
                menuBranding.classList.add("show");
                navItems.forEach((item) => item.classList.add("show")); 
                fruin_hidden_nav.style.display = "block";

                // Reset the menu state
                showMenu = true;
            } else {
                menuBtn.classList.remove("close");
                menu.classList.remove("show");
                menuNav.classList.remove("show");
                menuBranding.classList.remove("show");
                navItems.forEach((item) => item.classList.remove("show"));
                fruin_hidden_nav.style.display = "none";

                // Reset the menu state
                showMenu = false;
            }
        }
    }
}

export default Header;